// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries

// Components
import Lines from './Lines'
import Sidebar from './Sidebar'
import Mobile from './Mobile'
import { PoweredBy } from 'shop-components/components/PoweredBy'

// Shared
import { setUserFrameworkCartData } from 'shared/utils/userFrameworkEvents'

class EmbeddableCart extends Component {
  static displayName = 'EmbeddableCart'

  static propTypes = {
    cart: PropTypes.object,
    showPoweredBy: PropTypes.bool,
    t: PropTypes.func
  }

  state = {
    triggeredTracking: false,
    renderMobileForDesktop: false
  }

  get isMobile () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
      this.state.renderMobileForDesktop
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleWindowResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowResize)
  }

  componentDidUpdate = (prevProps) => {
    const { cart } = this.props

    if (cart !== prevProps.cart) {
      setUserFrameworkCartData()
    }

    // On mount window.Booqable.data is not set yet. By keeping track of whether this is triggered,
    // we can use the data in reporting events
    if (window.Booqable.cartData && !this.state.triggeredTracking) {
      this.setState({ triggeredTracking: true })

      window.Booqable._trigger('viewCart')
    }
  }

  handleWindowResize = () => {
    const renderMobileForDesktop = window.innerWidth <= 991

    if (renderMobileForDesktop !== this.state.renderMobileForDesktop) {
      this.setState({ renderMobileForDesktop })
    }
  }

  renderDesktop () {
    const { showPoweredBy } = this.props

    return (
      <div className="bq-cart">
        <div className="row">
          <div className="col-lg-8 bq-cart__lines">
            <Lines />
            {showPoweredBy && (
              <div className="bq-poweredby">
                <PoweredBy logoWidth="16px" />
              </div>
            )}
          </div>
          <div className="col-lg-4 bq-cart__sidebar">
            <Sidebar />
          </div>
        </div>
      </div>
    )
  }

  renderMobile () {
    const { showPoweredBy } = this.props

    return <Mobile showPoweredBy={showPoweredBy} />
  }

  render () {
    return this.isMobile ? this.renderMobile() : this.renderDesktop()
  }
}

const mapStateToProps = (state) => {
  const cart = state.orm.carts.first()

  return {
    cart,
    showPoweredBy: state.settings.get('store.show_powered_by')
  }
}

export default reduxConnect(mapStateToProps)(EmbeddableCart)
